import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  var _a;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { o365ThrottleEnabled, o365StoreFullMessage, timeoutGracePeriodMinutes } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "o365ThrottleEnabled", defaultChecked: o365ThrottleEnabled == null ? void 0 : o365ThrottleEnabled.value, onChange }),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "o365StoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: o365StoreFullMessage == null ? void 0 : o365StoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("o365.advanced.store_full_message_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "timeoutGracePeriodMinutes",
        type: "number",
        min: "1",
        value: (_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : "",
        onChange,
        label: t("o365.advanced.timeout_grace_period"),
        help: t("o365.advanced.timeout_grace_period_help")
      }
    )
  );
};
export default FormAdvancedOptions;
